import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

const StatusChip = ({ label, color, backgroundColor, textColor = color, sx, ...props }) => {
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        border: `1px solid ${color}`,
        backgroundColor,
        color: textColor,
        height: 24,
        ...sx,
      }}
      {...props}
    />
  );
};

StatusChip.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  sx: PropTypes.object,
};

StatusChip.defaultProps = {
  textColor: undefined,
  sx: undefined,
};

export default StatusChip;
